<div id="{{position}}" class="position-relative">
  <div>
    <header [attr.data-aos]="allElementAnimation ? allElementAnimation : null"
      class="app-header-background rp-video-header"
      [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor.includes('#')?'none':backgroundColor }">
      <div class="app-header-section hero-video-section global-max-width">
        <div [attr.data-aos]="textAnimation ? textAnimation : null"
          [fxLayoutAlign]="videoPosition === 'center'?'start center':'center center'"
          [fxLayout]="videoPosition === 'center'?'column':'row'" fxLayout.sm="column" fxLayout.xs="column"
          class="flex-video">
          <div fxFlex [fxFlexOrder]="videoPosition == 'right' || videoPosition == 'center' ? 1 : 2" fxFlex.lt-sm="100%"
            class="app-header-headline" [ngStyle]="{ 'text-align': textAlign }">
            <h1 [ngStyle]="{ 'font-family':titleFontFamily ? titleFontFamilyName : '','color': titleColor?titleColor:textColor,'font-weight':fontWeight }" class="mat-h1"
              [ngClass]="[titleSize]" [innerHtml]="title | safeHtml"> </h1>
            <h2 [ngStyle]="{ 'color': textColor }" [class]="textSize" [innerHtml]="text | safeHtml"> </h2>
          </div>
          <div [attr.data-aos]="videoAnimation ? videoAnimation : null" fxFlex
            [fxFlexOrder]="videoPosition == 'right' || videoPosition == 'center' ? 2 : 1" fxFlex.lt-sm="100%"
            class="app-header-start rp-video-center">
            <iframe [ngStyle]="{ 'display': displayVideo?'block':'none' }" title="{{ title }}" class="iframe-video"
              [src]="safeVideo" [width]="videoWidth" [height]="videoHeight" frameborder="0" allow="autoplay; fullscreen"
              allowfullscreen>
            </iframe>
            <div [ngStyle]="{ 'display': !displayVideo?'block':'none','background-image': (style$ | async) }"
              class="video-background-cover">
              <div id="container">
                <div class="item">
                  <a class="play-button" (click)="changeDisplayVideo()" tabindex="0">
                    <mat-icon class="sidenav-close-icon">play_arrow</mat-icon>
                  </a>
                </div>
                <div class="circle" style="animation-delay: -3s"></div>
                <div class="circle" style="animation-delay: -2s"></div>
                <div class="circle" style="animation-delay: -1s"></div>
                <div class="circle" style="animation-delay: 0s"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</div>